import AlertBanner from "@/pages/home/components/AlertBanner";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function ContactUs() {
  return (
    <div className="min-h-screen flex flex-col">
      <AlertBanner />
      <Header />
      <main className="flex-1">
        {/* Two-column content section */}
        <section className="w-full bg-background-50 py-12 md:py-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-0 overflow-hidden rounded-lg">
              {/* Left column — accent background */}
              <div className="w-full lg:w-1/2 bg-primary-500 text-background-50 p-8 md:p-10">
                <h4 className="text-2xl md:text-3xl font-bold mb-6">
                  Get In Touch
                </h4>

                <p className="text-background-50 font-bold mb-2">
                  Customer Service Office Hours:
                </p>
                <p className="text-background-50/90 leading-relaxed mb-1">
                  Staff available weekdays: 8:00am – 5:00pm
                </p>
                <p className="text-background-50/90 leading-relaxed mb-4">
                  Information about schedules, fares, travel alerts and more available 24/7 at (712) 206-1196
                </p>
                <p className="text-background-50/90 leading-relaxed mb-6">
                  Closed on weekends
                </p>

                <p className="text-background-50 font-bold mb-2">
                  Bus Service Hours:
                </p>
                <p className="text-background-50/90 leading-relaxed mb-4">
                  Southern Transit buses run 365 days per year with departures that vary dependent on route.
                </p>
                <p className="text-background-50/90 leading-relaxed mb-4">
                  Weekdays and weekends – please check your schedule for stop times.
                </p>
                <p className="text-background-50/90 leading-relaxed">
                  Service on the following holidays may be limited (please call (712) 206-1196 or check the website for holiday times): New Year's Day, Thanksgiving, and Christmas.
                </p>
              </div>

              {/* Right column — white background */}
              <div className="w-full lg:w-1/2 bg-background-50 p-8 md:p-10">
                <p className="text-primary-600 font-bold mb-2">
                  Telephone:
                </p>
                <p className="text-foreground-700 leading-relaxed mb-1">
                  Main: (712) 206-1196
                </p>
                <p className="text-foreground-700 leading-relaxed mb-1">
                  <a
                    href="mailto:lynn@southerntransit.us"
                    className="text-primary-600 hover:underline"
                  >
                    Email Lost and Found
                  </a>
                </p>
                <p className="text-foreground-700 leading-relaxed mb-6">
                  TDD: Contact us via Colorado Relay at 711
                </p>

                <p className="text-primary-600 font-bold mb-2">
                  Main Office:
                </p>
                <p className="text-foreground-700 leading-relaxed mb-1">
                  Southern Transit LLC
                </p>
                <p className="text-foreground-700 leading-relaxed mb-1">
                  9245 County Road 43.6
                </p>
                <p className="text-foreground-700 leading-relaxed mb-6">
                  Trinidad, Colorado 81082
                </p>

                <p className="text-primary-600 font-bold mb-2">
                  Email:
                </p>
                <p className="text-foreground-700 leading-relaxed mb-2">
                  Comments and Questions:{" "}
                  <a
                    href="mailto:lynn@southerntransit.us"
                    className="text-primary-600 hover:underline"
                  >
                    Email us
                  </a>{" "}
                  with a general question, statement, concern, or complaint and we will respond as soon as possible.
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  <a
                    href="mailto:lynn@southerntransit.us"
                    className="text-primary-600 hover:underline"
                  >
                    lynn@southerntransit.us
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}